module.exports = __webpack_public_path__ + "img/qr_icon.96313094.svg";